<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Select_Inquiry_Responsible')"
    width="1150px"
    :close-on-click-modal="false"
  >
    <!--干线运价负责人-->
    <div
      v-if="showTrunkLine"
      class="section grid-wrapper"
    >
      <span>{{ $t('CargoMsg.Cargo_Mainline_Rate_Leader') }}</span>
      <cargo-ag-grid-wrapper
        config-module="2025050271"
        :grid-options="trunkLinePerson.gridOptions"
        :column-defs="trunkLinePerson.columnDefs"
        :row-data="trunkLinePersonData"
        :show-selected-color="false"
        :check-sub-record="false"
        style="height: 100%;"
        @gridReady="params=>{trunkLinePerson.gridApi=params.api}"
      />
    </div>
    <!--港前运价负责人-->
    <div v-if="showPrePort" class="section grid-wrapper">
      <span>{{ $t('CargoMsg.Cargo_Pre_Port_Rate_Leader') }}</span>
      <cargo-ag-grid-wrapper
        config-module="2025050272"
        :grid-options="prePortPerson.gridOptions"
        :column-defs="prePortPerson.columnDefs"
        :row-data="prePortPersonData"
        :show-selected-color="false"
        :check-sub-record="false"
        style="height: 100%;"
        @gridReady="params=>{prePortPerson.gridApi=params.api}"
      />
    </div>
    <!--尾程运价负责人-->
    <div v-if="showLastMile" class="section grid-wrapper">
      <span>{{ $t('CargoMsg.Cargo_End_Route_Rate_Leader') }}</span>
      <cargo-ag-grid-wrapper
        config-module="2025050273"
        :grid-options="lastMilePerson.gridOptions"
        :column-defs="lastMilePerson.columnDefs"
        :row-data="lastMilePersonData"
        :show-selected-color="false"
        :check-sub-record="false"
        style="height: 100%;"
        @gridReady="params=>{lastMilePerson.gridApi=params.api}"
      />
    </div>
    <span slot="footer">
      <el-button type="primary" @click="confirmHandle">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'

export default {
  name: 'InquiryResponsiblePersonDialog',
  components: { cargoAgGridWrapper },
  props: {
    visible: { type: Boolean, required: true },
    form: { type: Object, default: () => {} },
    showTrunkLine: { type: Boolean, default: true }, // 干线价格勾选，且干线运价未选中
    showPrePort: { type: Boolean, default: true }, // 港前价格勾选，且港前运价未选中
    showLastMile: { type: Boolean, default: true }, // 尾程价格勾选，且尾程运价未选中
    trunkLinePersonData: { type: Array, default: () => [] },
    prePortPersonData: { type: Array, default: () => [] },
    lastMilePersonData: { type: Array, default: () => [] }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      trunkLinePerson: { // 干线运价负责人
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          }
        },
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Airline'),
            field: 'commerceName',
            colId: 'commerceName',
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'port',
            colId: 'port',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getSeaAirPortLabel(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.ResponsiblePerson'),
            field: 'userId',
            colId: 'userId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<input type="checkbox" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', ${code}, this.checked)" />`
            }
          }
        ]
      },
      prePortPerson: { // 干线运价负责人
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          }
        },
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Airline'),
            field: 'commerceName',
            colId: 'commerceName',
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'port',
            colId: 'port',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getSeaAirPortLabel(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.ResponsiblePerson'),
            field: 'userId',
            colId: 'userId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code
              return `<input type="checkbox" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', ${code}, this.checked)" />`
            }
          }
        ]
      },
      lastMilePerson: { // 干线运价负责人
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          }
        },
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Airline'),
            field: 'commerceName',
            colId: 'commerceName',
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'port',
            colId: 'port',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getSeaAirPortLabel(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.ResponsiblePerson'),
            field: 'userId',
            colId: 'userId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code
              return `<input type="checkbox" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', ${code}, this.checked)" />`
            }
          }
        ]
      }
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('radioClickHandler', function(uuid, type, checked) {
      context.radioClickHandler(uuid, type, checked)
    })
  },
  methods: {
    getListSeparator() {
      return this.$i18n && this.$i18n.locale === 'zh' ? '、' : ', '
    },
    radioClickHandler(uuid, type, checked) {
      let data
      let gridApi
      if (type === SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code) {
        data = this.trunkLinePersonData
        gridApi = this.trunkLinePerson.gridApi
      } else if (type === SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) {
        data = this.prePortPersonData
        gridApi = this.prePortPerson.gridApi
      } else if (type === SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code) {
        data = this.lastMilePersonData
        gridApi = this.lastMilePerson.gridApi
      }
      data.forEach(p => {
        if (p.uuid === uuid) {
          p.selected = !!checked
        }
      })
      gridApi.refreshCells({ force: true })
    },
    confirmHandle() {
      const trunkLinePersonUserIds = this.showTrunkLine
        ? this.trunkLinePersonData.filter(p => !!p.selected).map(p => Number(p.userId)).filter(p => p > 0)
        : []
      const prePortPersonUserIds = this.showPrePort
        ? this.prePortPersonData.filter(p => !!p.selected).map(p => Number(p.userId)).filter(p => p > 0)
        : []
      const lastMilePersonUserIds = this.showLastMile
        ? this.lastMilePersonData.filter(p => !!p.selected).map(p => Number(p.userId)).filter(p => p > 0)
        : []

      const missing = []
      if (this.showTrunkLine && trunkLinePersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_TrunkLine'))
      if (this.showPrePort && prePortPersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_PrePort'))
      if (this.showLastMile && lastMilePersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_FinalMile'))
      if (missing.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Inquiry_MissingBusinessCannotSubmit', [missing.join(this.getListSeparator())]))
        return
      }

      this.$emit('confirm', {
        trunkLinePersonUserIds,
        prePortPersonUserIds,
        lastMilePersonUserIds,
        // legacy single value (backward compatible)
        trunkLinePersonUserId: trunkLinePersonUserIds[0] || 0,
        prePortPersonUserId: prePortPersonUserIds[0] || 0,
        lastMilePersonUserId: lastMilePersonUserIds[0] || 0
      })
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.assembly-plan-dialog-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.assembly-plan-dialog-form .el-form-item {
  margin-left: 20px;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
  /deep/ .el-date-editor{
    width: 300px;
  }
}
</style>
